
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'paginatorComponent',
  props: {
    value: String,
    selectedValue:String
  },
  data () {
    return {
      isActive: false
    }
  },
  

})
